/* ============================================================
   is-reveal-tuning.js — Feintuning der Theme-Einblendungen
   Muss in theme.liquid ZWISCHEN vendor.js und theme.js geladen werden
   (defer). Ändert nichts am Theme-Code, stellt nur drei Regler nach:
   Dauer, Startpunkt und Staffelung der Original-Animation.
   Zum Abschalten: Script-Tag aus theme.liquid entfernen.
   ============================================================ */
(function () {
  /* ---------- REGLER ---------- */

  /* Dauer in Sekunden für fade-up / fade-in.
     Theme-Standard: 1.5 (zoom-out 1.3, fade-up-large 1.0). */
  var REVEAL_DURATION = 0.9;

  /* Startpunkt. Theme-Standard: '' = Animation startet erst, wenn das
     Element den unteren Bildschirmrand berührt. Positiver Wert unten
     (z. B. '0px 0px 120px 0px') = startet schon 120 px BEVOR das Element
     ins Bild kommt, wirkt dadurch früher. '' = Theme-Verhalten. */
  var REVEAL_TRIGGER_MARGIN = '0px 0px 120px 0px';

  /* Multiplikator für alle data-animate-delay-Werte.
     1 = wie in der Section eingetragen, 0.6 = 250 ms werden zu 150 ms. */
  var REVEAL_DELAY_SCALE = 0.6;

  /* ---------- AB HIER NICHTS ÄNDERN ---------- */

  var EASE = [0.16, 1, 0.3, 1]; /* Original-Easing des Themes */
  var REVEAL_TAGS = ['ANIMATE-ELEMENT', 'PICTURE', 'MOTION-LIST', 'PRODUCT-INFO'];

  /* 1) Startpunkt: Motion.inView wird vor theme.js umhüllt, damit die
        Reveal-Elemente ihren Beobachter mit Vorlauf anlegen. Alle anderen
        inView-Aufrufe des Themes bleiben unverändert. */
  if (window.Motion && typeof Motion.inView === 'function' && REVEAL_TRIGGER_MARGIN) {
    var origInView = Motion.inView;
    Motion.inView = function (target, onStart, options) {
      var isReveal = target && target.nodeType === 1 &&
        REVEAL_TAGS.indexOf(target.tagName) !== -1 &&
        (target.tagName !== 'PICTURE' || target.getAttribute('is') === 'animate-picture');
      if (isReveal && (!options || options.margin === undefined)) {
        options = Object.assign({ margin: REVEAL_TRIGGER_MARGIN }, options || {});
      }
      return origInView(target, onStart, options);
    };
  }

  /* 2) Dauer + Staffelung: nach theme.js (DOMContentLoaded läuft erst,
        wenn alle defer-Skripte durch sind) den Animations-Prototyp nachstellen.
        Die Beobachter feuern erst im nächsten Render-Schritt, also danach. */
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.theme || !theme.Animation || !window.Motion) return;
    var P = theme.Animation.prototype;

    if (REVEAL_DELAY_SCALE !== 1) {
      Object.defineProperty(P, 'delay', {
        configurable: true,
        get: function () {
          var raw = this.container.hasAttribute('data-animate-delay')
            ? parseInt(this.container.getAttribute('data-animate-delay'), 10) : 0;
          return (raw * REVEAL_DELAY_SCALE) / 1000;
        }
      });
    }

    P.load = async function () {
      if (this.type === 'none' || this.paused) return;
      var to = null, dur = REVEAL_DURATION;
      switch (this.type) {
        case 'fade-in':       to = { opacity: 1 }; break;
        case 'fade-up':       to = { transform: 'translateY(0)', opacity: 1 }; break;
        case 'fade-up-large': to = { transform: 'translateY(0)', opacity: 1 }; dur = REVEAL_DURATION * 0.7; break;
        case 'zoom-out':      to = { transform: 'scale(1)' }; dur = REVEAL_DURATION * 0.9; break;
      }
      if (to) {
        await Motion.animate(this.container, to, { duration: dur, delay: this.delay, easing: EASE }).finished;
      }
      this.container.classList.add('animated');
    };
  });
})();
